setTimeout(() => {
  if(BSS_B2B){
    if(window.location.pathname.includes('/collections/')){

      BSS_B2B.qi.invalidIncrementCollectionItems = new Map();
BSS_B2B.qi.handleSetupQuantityForCollectionPage = function () {
        const productIdArray = Array.from(document.querySelectorAll("[bss-b2b-product-qi-id]"));
        if (productIdArray && productIdArray.length) {
            let handleURLs = [];
            let handles = [];
            const idElements = new Map();
            productIdArray.forEach(item => {
                let proId =
                    item.getAttribute("bss-b2b-product-qi-id") ||
                    item.getAttribute("bss-b2b-product-id");
                if (handles.indexOf(proId) === -1) {
                    handles.push(proId);
                    handleURLs.push('id:"' + proId + '"');
                    idElements.set(proId, item);
                }
            })
            let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
            let encodeUrlData = encodeURI(urlData);
            fetch(encodeUrlData, { method: 'GET' }).then(async (data) => {
                let responseProducts = [];
                let productIdNoMetaField = [];
                try {
                    responseProducts = await data.json();
                    responseProducts.map(item => productIdNoMetaField.push(item.id));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('B2B: JSON parse returns no item');
                }

                if (responseProducts.length > 0) {
                    let productMap = [];
                    let checkUnique = [];
                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            const productVariant = pro.variants.map((variant) => (variant.id));
                            productMap.push({
                                id: pro.id,
                                tags: pro.tags,
                                product_name: pro.title,
                                collections: pro.collections,
                                variantsApplied: productVariant,
                            });
                        }
                    }
                    if (productMap && productMap.length > 0) {
                        let appliedQiRule = BSS_B2B.qi.getAppliedRulesForCollectionPage(productMap);

                        if (appliedQiRule.length) {
                            appliedQiRule.forEach(item => {
                                const id = item.id;
                                const itemIdOnPage = idElements.get(id.toString());
                                if (itemIdOnPage) {
                                    const quantity_element = itemIdOnPage.querySelector("quantity-input, .grid__item, .card-wrapper, .quantity-selector__wrapper");
                                    if (quantity_element) {
                                        handleSetup(quantity_element, item, itemIdOnPage)
                                    }
                                }
                            })
                        }
                    }
                }
            })
        }
}

BSS_B2B.qi.getAppliedRulesForCollectionPage = function (productMap) {
        let ruleList = BSS_B2B.qi.qiRules;
        ruleList.sort((a, b) => {
            return a.priority - b.priority;
        });
        let customer = BSS_B2B.shopData?.customer;
        let appliedRuleList = new Map();
        const checkQiMap = new Map();
        ruleList.forEach(function (rule) {
            let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let excludeCustomerTags = rule.exc_customer_tags;
            let exc_customers = rule.exc_customers;

            if (excludeFrom === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase());
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag));
                    if (checkArray.length > 0) {
                        return true;
                    }
                }
            } else if (excludeFrom === 2) {
                if (exc_customers) {
                    if (exc_customers.includes(`${customer.id}`)) {
                        return true;
                    }
                }
            }

            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let customerTagsInRule = rule.customer_tags;

            if (applyTo === 1) {
                if (customer.id == null) {
                    return true;
                }
            } else if (applyTo === 2) {
                if (customer.id !== null) {
                    return true;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return true;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return true;
                    }
                }
            } else if (applyTo === 4) {
                if (customer.tags == null) {
                    return true;
                } else {
                    customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase());
                    let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag));
                    if (checkArray.length === 0) {
                        return true;
                    }
                }
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(",").map(tag => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            let specificVariantIds = rule.product_variants ? rule.product_variants.split(",") : [];

            for (let i = 0; i < productMap.length; i++) {
                let isApplied = false;
                let collections = productMap[i].collections;
                let variantSelectedId = productMap[i].variantsApplied;
                let tags = productMap[i].tags.map(tag => tag.toLowerCase());
                let productId = productMap[i].id;
                let productTitle = productMap[i].product_name;
                // let variantSelector = $('form[action*="/cart/add"]').find('select[name="id"], input[name="id"], select[data-variant-input], .option-lists');
                // let variantId = variantSelector ? variantSelector.val() || variantSelector.attr('value') : null;

                let ruleList = {
                    'id': productId,
                    'name': rule.name,
                    'product_name': productTitle,
                    'rule_id': rule.id,
                    'qty_increment': rule.qty_increment,
                    'qty_increment_max': rule.qty_increment_max,
                    'qty_increment_min': rule.qty_increment_min,
                    'qty_increment_type': rule.qty_increment_type,
                };

                if (conditionType === 4) {
                    if (variantSelectedId && variantSelectedId.length) {
                        let variantAppliedMap = checkQiMap.get(productId) || new Map();
                        for (const variantId of variantSelectedId) {
                            let appliedQiRule = false;
                            if (specificVariantIds.indexOf(variantId + "") !== -1) {
                                appliedQiRule = true;
                            }
                            if (appliedQiRule) {
                                variantAppliedMap.set(variantId, true);
                            }
                        }
                        if (variantAppliedMap.size && variantAppliedMap.size === variantSelectedId.length) {
                            isApplied = true;
                            variantAppliedMap.clear();
                        }
                        checkQiMap.set(productId, variantAppliedMap);
                    }
                } else {
                    if (conditionType === 0) {
                        isApplied = true;
                    } else if (conditionType === 1) {
                        if (specificProductIds.indexOf(productId + "") !== -1) {
                            isApplied = true;
                        }
                    } else if (conditionType === 2) {
                        let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                        if (checkArray.length > 0) {
                            isApplied = true;
                        }
                    } else if (conditionType === 3) {
                        let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                        if (checkArray.length > 0) {
                            isApplied = true;
                        }
                    }
                }

                if (isApplied && !appliedRuleList.get(productId)) {
                    appliedRuleList.set(productId, JSON.parse(JSON.stringify(ruleList)));
                }
            }
        })

        let finalAppliedQiRule = [];
        finalAppliedQiRule = [...appliedRuleList.values()];
        return finalAppliedQiRule;
    };

function handleSetup(element, item, itemIdOnPage, variantElements, isFeaturedProduct = false) {
    const addToCart = itemIdOnPage?.querySelector(BSS_B2B.buttonAddToCart);
    const themeCartQuantityUpdateElement = itemIdOnPage?.querySelector("quick-add-bulk, quick-order-list");
    console.log("element, item:", element, item)
    const {
        quantityInputElement,
        quantityMinusElement,
        quantityPlusElement,
        incrementQuantity,
        minQuantity,
        maxQuantity,
        compareCase
    } = getQuantityElementsAndDetails(element, item);
    let incrementType = item.qty_increment_type;
    let currentQtyValue = parseInt(quantityInputElement?.value);

    let newValue = minQuantity;
    let defaultQuantityValue = minQuantity;
    
    if (
        incrementType === 0 &&
        quantityInputElement && !themeCartQuantityUpdateElement
    ) {
        switch (true) {
            case compareCase < 0:
                newValue =
                    closestGreaterOrEqualMultiple(
                        incrementQuantity,
                        minQuantity
                    );
                break;
            case compareCase > 0:
                if (minQuantity === 0) {
                    newValue =
                        closestLessOrEqualMultiple(
                            incrementQuantity,
                            maxQuantity
                        );
                } else {
                    newValue =
                        closestGreaterOrEqualMultiple(
                            incrementQuantity,
                            minQuantity
                        );
                }
                break;
        }
        quantityInputElement.value = newValue;
        defaultQuantityValue = newValue;
        currentQtyValue = newValue;
    }

    let trackQtyChange = 0;

    if (quantityInputElement) {
        if (quantityInputElement.value > 1) {
            quantityMinusElement &&
                quantityMinusElement.classList.remove(
                    "disabled"
                );
            quantityMinusElement.style.pointerEvents = 'auto';
        }
        quantityInputElement.addEventListener("change", function () {
            trackQtyChange = parseInt(quantityInputElement.value);
            if (trackQtyChange === 1) {
                quantityMinusElement.style.pointerEvents = 'none';
            } else {
                quantityMinusElement.style.pointerEvents = 'auto';
            }
        })
    }

    handleClickEvent(element, item, defaultQuantityValue, currentQtyValue, themeCartQuantityUpdateElement)
    let qiMsgElement = itemIdOnPage?.querySelector('.qiCollectionNotifyMessageBSS');
    if (qiMsgElement) qiMsgElement.style.fontSize = '16px';
    if (addToCart && ((variantElements && variantElements?.length < 2) || !isFeaturedProduct)) {
        if (currentQtyValue > 0) {
            addToCart.removeAttribute('disabled');
        }
        if (addToCart.handleAddToCart) {
            addToCart.removeEventListener("click", addToCart.handleAddToCart);
        }
        let checkAddToCart = handleAddToCart(currentQtyValue, quantityInputElement, quantityMinusElement, quantityPlusElement, defaultQuantityValue, item);
        addToCart.handleAddToCart = checkAddToCart;
        addToCart.addEventListener("click", checkAddToCart);
    }
}


function getQuantityElementsAndDetails(element, item) {
    const quantityInputElement = element.querySelector('.quantity__input');
    const quantityMinusElement = element.querySelector('.qty-minus');
    const quantityPlusElement = element.querySelector('.qty-plus');
    const incrementQuantity = item.qty_increment;
    const minQuantity = item.qty_increment_min ? item.qty_increment_min : 0;
    const maxQuantity = item.qty_increment_max ? item.qty_increment_max : 0;
    const compareCase = maxQuantity - minQuantity;

    return {
        quantityInputElement,
        quantityMinusElement,
        quantityPlusElement,
        incrementQuantity,
        minQuantity,
        maxQuantity,
        compareCase
    };
}

function closestGreaterThanMin(a, b, c) {
    let d = Math.ceil(b / a) * a;
    while (d <= c) {
        d += a;
    }
    return d;
}
function closestGreaterOrEqualMultiple(a, b) {
    return Math.ceil(b / a) * a;
}

function closestLessOrEqualMultiple(a, b) {
    return Math.floor(b / a) * a;
}


const handleClickEvent = (element, item, defaultQuantityValue, currentQtyValue, quickAddElement) => {
    let {
        quantityMinusElement,
        quantityPlusElement,
        minQuantity,
        quantityInputElement
    } = getQuantityElementsAndDetails(element, item);

    let newValue = minQuantity;
    BSS_B2B.qi.validateQtyIncrementCollectionPage(item, null, quantityMinusElement, quantityPlusElement, quantityInputElement.value, defaultQuantityValue, currentQtyValue, quantityInputElement, item.id);
    if (quantityPlusElement) {
        if (quantityPlusElement.changeQuantityHandler) {
            quantityPlusElement.removeEventListener("click", quantityPlusElement.changeQuantityHandler);
        }

        const changeQuantityHandler = changeQuantity(element, item, currentQtyValue, defaultQuantityValue, newValue, "plus");
        quantityPlusElement.changeQuantityHandler = changeQuantityHandler;

        quantityPlusElement.addEventListener("click", changeQuantityHandler);
    }
    if (quantityMinusElement) {
        if (quantityMinusElement.changeQuantityHandler) {
            quantityMinusElement.removeEventListener("click", quantityMinusElement.changeQuantityHandler);
        }

        const changeQuantityHandler = changeQuantity(element, item, currentQtyValue, defaultQuantityValue, newValue, "minus");
        quantityMinusElement.changeQuantityHandler = changeQuantityHandler;

        quantityMinusElement.addEventListener("click", changeQuantityHandler);
    }
    if (quickAddElement) {
        if (quickAddElement) {
            if (element.observer) {
                element.observer.disconnect();
            }

            const observer = new MutationObserver((MutationList) => {
                for (let mutation of MutationList) {
                    if (mutation.target.className === 'variant-item') {
                        observer.disconnect();
                        let {
                            quantityInputElement
                        } = getQuantityElementsAndDetails(element, item);
                        currentQtyValue = quantityInputElement ? quantityInputElement?.value : 0;
                        handleClickEvent(element, item, defaultQuantityValue, currentQtyValue, quickAddElement);
                        observer.observe(element, { attributes: true, childList: true, subtree: true });
                    }
                }
            });

            observer.observe(element, { attributes: true, childList: true, subtree: true });
            element.observer = observer;
        }
    }
}

BSS_B2B.qi.validateQtyIncrementCollectionPage = function (appliedQiRule, element, quantityMinusElement, quantityPlusElement, realQtyValue, defaultQuantityValue, currentQtyValue, quantityInputElement, id) {
        const INVALID_INCREMENT = "INVALID_INCREMENT";
        const INVALID_INCREMENT_MAX = "INVALID_INCREMENT_MAX";
        const INVALID_INCREMENT_MIN = "INVALID_INCREMENT_MIN";
        const INVALID_ACTION = "INVALID_ACTION";

        let invalidIncrementRule = false;
        let invalidAction = false;
        let afterChangeQtyValue = 0;
        let qtyIncrement = appliedQiRule.qty_increment;
        let qtyIncrementMax = appliedQiRule.qty_increment_max;
        let qtyIncrementMin = appliedQiRule.qty_increment_min;
        let curElement = quantityInputElement?.closest('.card-wrapper, [bss-b2b-variant-qi-id], [bss-b2b-product-qi-id]');
        let quantityElement = curElement?.querySelector('quantity-input, quantity-selector, .quantity-input')

        if (qtyIncrementMin != null && qtyIncrementMax == null) {
            if (element == quantityMinusElement && realQtyValue < defaultQuantityValue) {
                invalidAction = INVALID_ACTION;
            }
        }

        if (qtyIncrementMax != null && qtyIncrementMin == null) {
            if (element == quantityMinusElement && realQtyValue < qtyIncrement) {
                invalidAction = INVALID_ACTION;
            }
            if (element == quantityPlusElement) {
                afterChangeQtyValue = closestGreaterThanMin(qtyIncrement, qtyIncrementMin, realQtyValue);
                if (realQtyValue === defaultQuantityValue) {
                    invalidAction = false;
                } else if (realQtyValue > defaultQuantityValue) {
                    invalidAction = INVALID_ACTION;
                } else if (afterChangeQtyValue > qtyIncrementMax) {
                    invalidAction = INVALID_ACTION;
                }
            }
        }

        if (qtyIncrementMax != null && qtyIncrementMin != null) {
            if (element == quantityMinusElement && realQtyValue < defaultQuantityValue) {
                invalidAction = INVALID_ACTION;
            }
            if (element == quantityPlusElement) {
                afterChangeQtyValue = closestGreaterThanMin(qtyIncrement, qtyIncrementMin, realQtyValue);
                if (realQtyValue > qtyIncrementMax) {
                    invalidAction = INVALID_ACTION;
                } else if (afterChangeQtyValue > qtyIncrementMax) {
                    invalidAction = INVALID_ACTION;
                }
            }
        }

        if (qtyIncrementMin == null && qtyIncrementMax == null && realQtyValue < qtyIncrement) {
            invalidAction = INVALID_ACTION;
        }

        if (currentQtyValue % qtyIncrement === 0) {
            if (qtyIncrementMin != null && currentQtyValue < qtyIncrementMin) {
                invalidIncrementRule = INVALID_INCREMENT_MIN;
            }
            if (qtyIncrementMax != null && currentQtyValue > qtyIncrementMax) {
                invalidIncrementRule = INVALID_INCREMENT_MAX;
            }
        } else {
            invalidIncrementRule = INVALID_INCREMENT;
        }

        if (invalidAction === false && invalidIncrementRule && (element == quantityMinusElement || element == quantityPlusElement)) {
            invalidIncrementRule = false;
        }

        let messageId = id;
        if (appliedQiRule.variantApplied) {
            messageId = appliedQiRule.variantApplied;
        }

        BSS_B2B.qi.invalidIncrementCollectionItems.set(Number(messageId), {
            isInvalid: invalidIncrementRule,
            currentValue: currentQtyValue,
            isActionInvalid: invalidAction
        })

        BSS_B2B.qi.showNotifyMessageCollectionPage(curElement, appliedQiRule, quantityElement, invalidIncrementRule, invalidAction);
        let qiMsgElement = curElement.querySelector('.qiCollectionNotifyMessageBSS');
        if (qiMsgElement) {
            if (invalidIncrementRule !== false || invalidAction !== false) {
                qiMsgElement.style.color = "red";
            } else {
                qiMsgElement.style.color = "unset";
            }
            qiMsgElement.style.fontSize = '16px';
        }
    }


BSS_B2B.qi.showNotifyMessageCollectionPage = function (curElement, appliedQiRule, quantityElement, invalidIncrementRule, invalidAction) {
        if (!appliedQiRule) {
            const qiMsgElement = curElement.querySelector('.qiNotifyMessageBSS');
            if (qiMsgElement) {
                qiMsgElement.remove();
            }
            return;
        }

        const { need_product_text, less_product_text, greater_product_text, and_product_text, not_satisfied_text } = BSS_B2B.qi.qiTranslations;

        let lessMsg = '';
        let greaterMsg = '';
        let qiProductMsg = '<div class="qiCollectionNotifyMessageBSS">';
        let needMsg = `<div class="needCollectionBSS">${need_product_text}<span> ${appliedQiRule.qty_increment}</span>`;
        let warningMsg = `<div class="notSatisfiedCollectionItem" style="color: red">(*) ${not_satisfied_text}</div>`
        let isQuickView = document.querySelector('.modal-inner product-variant-pop');

        if (appliedQiRule.qty_increment_max && appliedQiRule.qty_increment_max > 0) {
            lessMsg = `<span class="lessCollectionBSS"> ${less_product_text}<span> ${appliedQiRule.qty_increment_max}</span></span>`;
        }
        if (appliedQiRule.qty_increment_min && appliedQiRule.qty_increment_min > 0) {
            greaterMsg = `<span id="greaterCollectionBSS"> ${greater_product_text}<span> ${appliedQiRule.qty_increment_min}</span></span>`;
        }
        if (greaterMsg && lessMsg) {
            if (BSS_B2B.storeId === 14081) {
                needMsg = needMsg + '.' + greaterMsg + and_product_text;
            } else {
                needMsg = needMsg + ',' + greaterMsg + ', ' + and_product_text + lessMsg;
            }
        } else if (greaterMsg || lessMsg) {
            needMsg = needMsg + ', ' + and_product_text + greaterMsg + lessMsg;
        }

        let qiErrorMessage = curElement.querySelector(".qiCollectionNotifyMessageBSS");
        if (BSS_B2B.qi.qiSettings.display_notify_message === 1) {
            qiProductMsg = qiProductMsg + needMsg + "</div></div>";
            if (BSS_B2B.qi.qiSettings.popup_position === 0 || !isQuickView) {
                if (quantityElement) {
                    if (qiErrorMessage) {
                        qiErrorMessage.innerHTML = qiProductMsg;
                    } else {
                        if (isQuickView) {
                            quantityElement.parentElement.insertAdjacentHTML('afterend', qiProductMsg);
                        } else {
                            quantityElement.insertAdjacentHTML('beforebegin', qiProductMsg);
                        }
                    }
                }

            } else if (BSS_B2B.qi.qiSettings.popup_position === 1) {
                let isTimeout = false;
                let paymentInterval = setInterval(() => {
                    let paymentBtn = getBuyNowButton();
                    if (paymentBtn) {
                        if (qiErrorMessage) {
                            qiErrorMessage.innerHTML = qiProductMsg;
                        } else {
                            paymentBtn.insertAdjacentHTML('afterend', qiProductMsg);
                            clearInterval(paymentInterval);
                            isTimeout = true;
                        }
                    }
                }, 500);
                setTimeout(() => {
                    if (!isTimeout) clearInterval(paymentInterval);
                }, 5000);
            }
        } else {
            qiProductMsg = qiProductMsg + warningMsg + "</div>";
            if (quantityElement && invalidIncrementRule) {
                if (invalidIncrementRule !== false && invalidIncrementRule !== null) {
                    if (qiErrorMessage) {
                        qiErrorMessage.innerHTML = qiProductMsg;
                    } else {
                        quantityElement.insertAdjacentHTML('beforebegin', qiProductMsg);
                    }
                } else {
                    if (qiErrorMessage) {
                        qiErrorMessage.remove();
                    }
                }
            } else if (invalidAction) {
                if (qiErrorMessage) {
                    qiErrorMessage.innerHTML = qiProductMsg;
                } else {
                    quantityElement.insertAdjacentHTML('beforebegin', qiProductMsg);
                }
            } else {
                if (qiErrorMessage) {
                    qiErrorMessage.remove();
                }
            }
        }
    };

const changeQuantity = (element, item, currentQtyValue, defaultQuantityValue, newValue, type) => {
    return () => {
        const {
            quantityInputElement,
            quantityMinusElement,
            quantityPlusElement,
            incrementQuantity,
            minQuantity,
            maxQuantity,
            compareCase
        } = getQuantityElementsAndDetails(element, item);
        currentQtyValue = type === 'plus' ? parseInt(quantityInputElement.value) - 1 : parseInt(quantityInputElement.value) + 1;
        const target = type === 'plus' ? quantityPlusElement : quantityMinusElement;
        BSS_B2B.qi.validateQtyIncrementCollectionPage(item, target, quantityMinusElement, quantityPlusElement, quantityInputElement.value, defaultQuantityValue, currentQtyValue, quantityInputElement, item.id);
        newValue = calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, type);
        quantityInputElement.value = newValue;
    }
}

function calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, changeType) {
    let newValue = incrementQuantity;
    if (!maxQuantity && !minQuantity) {
        if (changeType === "plus") {
            if (currentQtyValue % incrementQuantity !== 0) {
                newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
            } else {
                newValue = currentQtyValue + incrementQuantity;
            }
        } else {
            if (currentQtyValue <= defaultQuantityValue) {
                newValue = currentQtyValue;
            } else {
                if (currentQtyValue % incrementQuantity !== 0) {
                    newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                } else {
                    if (currentQtyValue / incrementQuantity === 1) {
                        newValue = incrementQuantity
                    } else {
                        newValue = currentQtyValue - incrementQuantity;
                    }
                }
            }
        }
    } else {
        switch (true) {
            case compareCase < 0:
                if (changeType === "plus") {
                    if (currentQtyValue < minQuantity) {
                        newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                    } else {
                        if (currentQtyValue % incrementQuantity !== 0) {
                            newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
                        } else {
                            newValue = currentQtyValue + incrementQuantity;
                        }
                    }
                } else {
                    if (currentQtyValue <= defaultQuantityValue) {
                        newValue = currentQtyValue;
                    } else {
                        if (currentQtyValue % incrementQuantity !== 0) {
                            newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                        } else {
                            if (currentQtyValue / incrementQuantity === 1) {
                                newValue = incrementQuantity
                            } else {
                                newValue = currentQtyValue - incrementQuantity;
                                if (newValue < minQuantity) {
                                    newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                                }
                            }
                        }
                    }
                }
                break;
            case compareCase > 0:
                if (minQuantity === 0) {
                    if (changeType === "plus") {
                        if (currentQtyValue >= defaultQuantityValue) {
                            newValue = currentQtyValue;
                        } else {
                            if (currentQtyValue % incrementQuantity !== 0) {
                                newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
                            } else {
                                newValue = currentQtyValue + incrementQuantity;
                                if (newValue > maxQuantity) {
                                    newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                                }
                            }
                        }
                    } else {
                        if (currentQtyValue > maxQuantity) {
                            newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                        } else {
                            if (currentQtyValue < incrementQuantity) {
                                newValue = currentQtyValue;
                            } else {
                                if (currentQtyValue % incrementQuantity !== 0) {
                                    newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                                } else {
                                    if (currentQtyValue / incrementQuantity === 1) {
                                        newValue = incrementQuantity
                                    } else {
                                        newValue = currentQtyValue - incrementQuantity;
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if (minQuantity < currentQtyValue && currentQtyValue < maxQuantity) {
                        if (changeType === "plus") {
                            if (currentQtyValue % incrementQuantity !== 0) {
                                newValue = closestFitRangeInc(incrementQuantity, minQuantity, maxQuantity, currentQtyValue);
                            } else {
                                newValue = currentQtyValue + incrementQuantity;
                                if (newValue > maxQuantity) {
                                    newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                                }
                            }
                        } else {
                            if (currentQtyValue % incrementQuantity !== 0) {
                                newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                            } else {
                                if (currentQtyValue / incrementQuantity === 1) {
                                    newValue = incrementQuantity
                                } else {
                                    newValue = currentQtyValue - incrementQuantity;
                                    if (newValue < minQuantity) {
                                        newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                                    }
                                }
                            }
                        }
                    } else if (currentQtyValue >= maxQuantity) {
                        if (changeType === "plus") {
                            newValue = currentQtyValue;
                        } else {
                            if (currentQtyValue === maxQuantity) {
                                newValue = maxQuantity - incrementQuantity;
                            } else {
                                newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                            }
                        }
                    } else if (currentQtyValue <= minQuantity) {
                        if (changeType === "plus") {
                            newValue = closestGreaterThanMin(incrementQuantity, minQuantity, currentQtyValue);
                        } else {
                            newValue = currentQtyValue;
                        }
                    }
                }
                break;
        }
    }

    if (quantityMinusElement && newValue > 1) {
        quantityMinusElement.classList.remove("disabled");
    }

    return newValue;
}


    setTimeout(() => {
      BSS_B2B.qi.handleSetupQuantityForCollectionPage();
    }, 500)
      
    }
  }
}, 300)